import { createSelector } from 'reselect';
import sortByName from 'library/helpers/sort-by-name';

export const getItemsCategoriesFormatted = (state) => state.itemsCategories.data?.sort(sortByName);
export const getItemsCategoriesLoadingState = (state) => state.itemsCategories.loading;

// export const getItemsCategoriesFormatted = createSelector(
//   getItemsCategories,
//   (items) => items.map(({ category_name: name, category_id: id }) => ({ name, id })),
// );

export const getItemsCategoriesOptions = createSelector(
  getItemsCategoriesFormatted,
  (items) => items.map(({ name, id }) => ({ value: id, text: name })),
);
